import { Guid, ITranslations } from "@/types"
import ProductHierarchyProductFamily, { IGetProductHierarchyProductFamilyDto } from "./ProductHierarchyProductFamily"

export interface IGetProductHierarchyProductLineDto {
    id: Guid
    description: string
    descriptionTranslations: ITranslations
    familyCount: number
    families: IGetProductHierarchyProductFamilyDto[]
}

export default class ProductHierarchyProductLine {
    id: Guid
    description: string
    descriptions: ITranslations
    familyCount: number
    families: ProductHierarchyProductFamily[]

    constructor(dto: IGetProductHierarchyProductLineDto) {
        this.id = dto.id
        this.description = dto.description
        this.descriptions = dto.descriptionTranslations
        this.familyCount = dto.familyCount
        this.families = dto.families.map(f => new ProductHierarchyProductFamily(f))
    }

    get hasArticles() {
        return this.families.some(f => f.hasArticles)
    }
}
